import type { EncounterEdit } from "@/types/emr/encounter/encounter";
import type { QuestionValidationError } from "@/types/questionnaire/batch";
import {
  type FieldDefinitions,
  validateFields,
} from "@/types/questionnaire/validation";

export const ENCOUNTER_FIELDS: FieldDefinitions = {
  DISCHARGE_DISPOSITION: {
    key: "hospitalization.discharge_disposition",
    required: true,
  },
} as const;

export function validateEncounterQuestion(
  value: EncounterEdit | undefined,
  questionId: string,
): QuestionValidationError[] {
  if (
    value?.status === "discharged" &&
    ["imp", "obsenc", "emer"].includes(value.encounter_class) &&
    !value.hospitalization?.discharge_disposition
  ) {
    return validateFields(value, questionId, ENCOUNTER_FIELDS);
  }

  return [];
}
